import { render, staticRenderFns } from "./SportsPage.vue?vue&type=template&id=665ff8ee&"
import script from "./SportsPage.vue?vue&type=script&lang=js&"
export * from "./SportsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports